exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".test[data-v-23c768ae]{width:100%;height:200px;background-color:#fff}\n", ""]);

// exports
